import React from 'react';
import { ModernTimetable } from './modern';

const ModernTimetablePage: React.FC = () => <ModernTimetable />;

export default ModernTimetablePage;